import { ArrowUpDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu.tsx";
import { DataTableCenteredCell } from "@/shared/ui/DataTable";
import { Button } from "@/shared/ui/button.tsx";
import { StatusInfo } from "@/widgets/StatusInfo";
import { HoverCardInfo } from "@/features/HoverCardInfo";
import { useURLParamsData } from "@/shared/hooks/useURLParamsData.ts";
import { localizationMap } from "@/shared/lib/consts";
import { LeadRequestStatus } from "@/entities/lead-claim-request/model";

type StatusOption = {
  value: LeadRequestStatus | null;
  label: string;
};

const statusOptions: StatusOption[] = [
  { value: null, label: "Все статусы" },
  { value: LeadRequestStatus.APPROVED, label: "Одобрено" },
  { value: LeadRequestStatus.PENDING, label: "В ожидании" },
  { value: LeadRequestStatus.REJECTED, label: "Отклонен" },
];

export const LeadRequestStatusModal = () => {
  const { leadRequestStatus, setLeadRequestStatus } = useURLParamsData();

  return (
    <DropdownMenu>
      <DataTableCenteredCell className="flex flex-row">
        <DropdownMenuTrigger asChild>
          <Button className="text-thColor" variant="ghost">
            <p>
              {leadRequestStatus
                ? localizationMap[leadRequestStatus.toLowerCase()] ||
                  leadRequestStatus
                : "Статус"}
            </p>
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <StatusInfo />
      </DataTableCenteredCell>
      <DropdownMenuContent>
        {statusOptions.map(({ value, label }) => (
          <DropdownMenuItem
            key={value ?? "null"}
            className="overflow-y-auto"
            onClick={() => setLeadRequestStatus(value)}
          >
            {value ? (
              <HoverCardInfo text={label}>{label}</HoverCardInfo>
            ) : (
              label
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
